import { useMainStore } from '@/stores/main'

// 字典数组转换成对象
export const onChangeObject = (data: any) => {
  const obj: any = {}
  data.forEach((element: any) => {
    obj[element.dicKey] = element.dicValue
  })
  return obj
}
// 文件大小转换
export const onChangefileSize = (size: any) => {
  let data = ''
  if (size && size >= 1024 * 1024) {
    data = size >= 1024 * 1024 * 1024 ? (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB' : (size / (1024 * 1024)).toFixed(2) + 'MB'
  } else if (size && size >= 1024 && size < 1024 * 1024) {
    data = (size / 1024).toFixed(2) + 'KB'
  } else {
    data = size ? size + 'B' : ''
  }
  return data
}
// 格式化日期函数，年月日
export const getDateDay = (date: any) => {
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  return `${year}-${month}-${day}`
}
// 格式化日期函数，月日
export const getMonthDay = (date: any) => {
  let month = date.getMonth() + 1
  let day = date.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  return `${month}月${day}日`
}
// 格式化日期函数，月
export const getMonth = (date: any) => {
  let month = date.getMonth() + 1
  month = month < 10 ? '0' + month : month
  return `${month}月`
}
// 格式化日期函数，年月日时分秒，返回2023-8-10 12:21:39
export const getTime = (date: any) => {
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  hour = hour < 10 ? '0' + hour : hour
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds
  return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`
}

// 返回 2022-12-19 00:00:00
export const getDateTime = (val: any) => {
  const date = new Date(val)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${year}-${month}-${day} 00:00:00`
}

/* 时间范围
* 传入['2023-03-13', '2023-03-15']
* 返回['2023-03-13 00:00:00', '2023-03-15 23:59:59']
*/
export const setScopeDate = (data: string[]) => {
  if (!Array.isArray(data)) return null
  const newDate = []
  newDate[0] = data[0] + ' 00:00:00'
  newDate[1] = data[1] + ' 23:59:59'
  return newDate
}

// 获取本月1号到当前日期、本月1号到本月最后一天
export const getCurrentMonthNum = (date?: Date) => {
  const currentDate = date || new Date()
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth()

  // 本月第一天
  const firstDay = new Date(year, month, 1)
  // 本月最后一天
  const lastDay = new Date(year, month + 1, 0)

  // 格式化函数
  const formatDate = (d: Date) => {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  }

  return {
    newDate: [
      formatDate(firstDay),
      formatDate(currentDate)
    ],
    newAllDate: [
      formatDate(firstDay),
      formatDate(lastDay)
    ]
  }
}

// 获取本周周一到当前周天、本周周一到本周周日
export const getCurrentWeekNum = (date?: Date) => {
  const today = date || new Date()
  const dayOfWeek = today.getDay() // 0=周日, 1=周一, ..., 6=周六

  // 计算本周周一
  const monday = new Date(today)
  monday.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1))

  // 计算本周周日
  const sunday = new Date(today)
  sunday.setDate(today.getDate() + (dayOfWeek === 0 ? 0 : 7 - dayOfWeek))

  // 格式化函数
  const format = (date: Date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  return {
    newDate: [format(monday), format(today)],
    newAllDate: [format(monday), format(sunday)]
  }
}
// 获取一个日期范围内的所有日期，入参为Date对象
export const gainAllDateBetRange = (startDate: any, endDate: any) => {
  const dateArr: any = []
  if (!(startDate instanceof Date && endDate instanceof Date)) return dateArr // 非时间格式返回空数组
  const startTime = startDate.getTime() // 获取开始日期的毫秒数
  const endTime = endDate.getTime() // 获取结束日期的毫秒数
  const oneTime = 24 * 60 * 60 * 1000 // 一天的毫秒数
  for (let time = startTime; time <= endTime;) {
    dateArr.push(getDateDay(new Date(time))) // 将格式化后的时间存入结果数组
    time += oneTime // 每次加一天
  }
  return dateArr
}

// 获取今天昨天两天
export const getTwoDate = async () => {
  const date: any = new Date()
  const year: any = date.getFullYear()
  let month: any = date.getMonth() + 1
  let day: any = date.getDate()
  let beforeYear: any = year
  let beforeMonth: any = month
  let beforeDay: any = day - 1
  if (day === 1) {
    beforeYear = month === 1 ? year - 1 : year
    beforeMonth = month === 1 ? 12 : month - 1
    // 获取上个月多少天
    const lastDays = new Date(beforeYear, beforeMonth, 0).getDate() // 上个月多少天
    beforeDay = lastDays
  }
  beforeMonth = beforeMonth < 10 ? '0' + beforeMonth : beforeMonth
  beforeDay = beforeDay < 10 ? '0' + beforeDay : beforeDay
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  const data = {
    startDate: `${beforeYear}-${beforeMonth}-${beforeDay}`,
    endDate: `${year}-${month}-${day}`
  }
  return data
}
// 获取一个日期范围内的所有日期，入参为Date对象
/**
 * 根据字典键获取字典值
 * @param dicList 字典数组
 * @param dicKey 要查找的字典键
 * @returns 对应的字典值，未找到返回空字符串
 */
export const getDicName = <T extends { dicKey: string | number; dicValue: any }>(
  dicList: T[] | null | undefined,
  dicKey: string | number | null | undefined
): string => {
  if (!dicList || !dicKey) return ''

  const foundItem = dicList.find(item =>
    String(item.dicKey) === String(dicKey)
  )

  return foundItem?.dicValue ?? ''
}

/**
 * 判断是否有权限
 * @param permissionValue
 */
export function hasPermission (permissionValue: string): boolean {
  const store = useMainStore()
  const permissionsInfo: any = store.permissionsList || []
  return permissionsInfo.includes(permissionValue)
}

/**
 * 判断是否有角色
 * @param roleValue
 */
export function hasRole (roleValue: string): boolean {
  const store = useMainStore()
  const rolesList: any = store.rolesList || []
  return rolesList.includes(roleValue)
}

/**
 * 判断是否有海外政府角色
 * @returns 是否有海外政府角色
 */
export function isOfficialRole (): boolean {
  // 从环境变量获取官方角色配置
  const officialRoles = process.env.VUE_APP_OFFICIAL_ROLE?.split(',') || []

  // 获取当前用户的角色列表
  const store = useMainStore()
  const rolesList: string[] = store.rolesList || []

  // 如果没有配置官方角色或用户没有角色，返回 false
  if (officialRoles.length === 0 || rolesList.length === 0) {
    return false
  }

  // 判断用户的角色列表中是否包含任何官方角色
  return rolesList.some(role => officialRoles.includes(role))
}
/**
 * 将可能是对象或数组的JSON字符串统一转换为数组
 * @param dataStr JSON字符串，可能是对象或数组结构
 * @returns 转换后的数组，解析失败返回空数组
 */
export function objToArray<T = any> (dataStr: string): T[] {
  // 统一转换为数组形式
  let dataArray: T[] = []

  if (!dataStr) {
    return dataArray
  }

  try {
    const parsedData = JSON.parse(dataStr)

    if (Array.isArray(parsedData)) {
      dataArray = parsedData
    } else if (parsedData && typeof parsedData === 'object') {
      // 如果是对象格式，提取所有值组成数组
      dataArray = Object.values(parsedData)
    }
  } catch (e) {
    console.error('JSON解析失败:', e)
  }

  return dataArray
}

// src/utils/date.js

// src/utils/date.ts

/**
 * 通用日期格式化函数
 * @param {string | Date} date - 输入日期（支持 "YYYY-MM-DD" 或 Date 对象）
 * @param {string} format - 目标格式（如 "YYYY-MM-DD", "MM/DD/YYYY", "MMMM YYYY"）
 * @returns {string} 格式化后的日期字符串
 */
export const getDateFormat = (date: string | Date, format: string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date

  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    return 'Invalid Date'
  }

  const year = dateObj.getFullYear()
  const month = dateObj.getMonth() + 1 // 0-11 → 1-12
  const day = dateObj.getDate()

  const englishMonths = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]
  const englishMonthAbbreviations = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  return format
    .replace('YYYY', year.toString())
    .replace('MMMM', englishMonths[month - 1])
    .replace('MMM', englishMonthAbbreviations[month - 1])
    .replace('MM', month.toString().padStart(2, '0'))
    .replace('DD', day.toString().padStart(2, '0'))
}
